import apiServices from '../../apiServices';

export const requestCompany = (companyName: string) => async () => {
    const {data: company, ok: isSuccess, status: statusCode} = await apiServices.getCompany(companyName);

    return {company, isSuccess, statusCode};
};
